module.exports = __webpack_public_path__ + "Faq_Header_new.fdeb790b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Faq_Header_new.png
// module id = 2akG
// module chunks = 0